


























import {
  defineComponent,
  onMounted,
  onUnmounted,
  PropType,
  ref,
} from '@nuxtjs/composition-api'

type PropPosition = 'left' | 'right'

export default defineComponent({
  name: 'RgsModalAside',
  props: {
    position: {
      type: String as PropType<PropPosition>,
      default: 'right',
    },
    appearance: {
      type: String,
      default: 'right',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(_props, { emit }) {
    const isMounted = ref(false)
    const onClose = () => {
      isMounted.value = false
    }
    const onAfterLeave = () => {
      emit('close')
    }
    onMounted(() => {
      isMounted.value = true
    })
    onUnmounted(() => {
      isMounted.value = false
    })
    return {
      isMounted,
      onClose,
      onAfterLeave,
    }
  },
})
